import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Carousel from 'react/views/carousel/Carousel';
import { CarouselItemWidth } from 'react/views/carousel/CarouselItem';
import './carouselView.less'

/**
 * A generic view component for rendering Titles in a Carousel.
 * Optionally renders a header above the Carousel.
 * Optionally renders a footer below the Carousel.
 *
 * @class CarouselView
 * @extends {Component}
 */
class CarouselView extends Component {
	renderCarousel() {
		let carouselProps = {
			width: this.props.width,
			itemWidth: this.props.itemWidth,
			reportUpdate: this.props.reportUpdate,
			slidesToShow: this.props.slidesToShow
		};

		if(this.props.marginTop || this.props.marginTop === 0){
			carouselProps.marginTop = this.props.marginTop;
		}

		if(this.props.marginBottom || this.props.marginBottom === 0){
			carouselProps.marginBottom = this.props.marginBottom;
		}

		if (this.props.minMargin || this.props.minMargin === 0) {
			carouselProps.minMargin = this.props.minMargin;
		}

		return (
			<Carousel {...carouselProps}>
				{this.props.items}
			</Carousel>
		);
	}

	renderHeader() {
		return (
			<header>
				{this.props.header}
			</header>
		);
	}

	renderFooter() {
		return (
			<footer>
				{this.props.footer}
			</footer>
		);
	}

	render() {
		return (
			<div className="title-carousel-view" ref={this.props.measureRef}>
				{this.props.header && this.renderHeader()}

				{this.props.items && this.renderCarousel()}

				{this.props.footer && this.renderFooter()}
			</div>
		);
	}
}

CarouselView.propTypes = {
	header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	footer: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	items: PropTypes.arrayOf(PropTypes.object),
	itemWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	minMargin: PropTypes.number,
	reportUpdate: PropTypes.func,
	slidesToShow: PropTypes.number
};

CarouselView.defaultProps = {
	itemWidth: CarouselItemWidth
};

export default CarouselView;



// WEBPACK FOOTER //
// ./src/react/views/carousel/CarouselView.jsx